// extracted by mini-css-extract-plugin
export default {"wrapper":"mR-z","availablePromoMessagesLabel":"nR-z","promoMessageList":"oR-z","promoMessage":"pR-z","appliedPromoMessage":"qR-z","promoMessageAmount":"rR-z"};